export const faqs = {
  hero: {
    title: 'Frequently Asked Questions',
    subtitle: 'Find answers to the most common questions about VELXIA'
  },
  categories: {
    general: 'General',
    technical: 'Technical',
    pricing: 'Pricing',
    security: 'Security'
  },
  general: {
    title: 'General',
    q1: {
      question: 'What is VELXIA?',
      answer: 'VELXIA is an AI-powered platform that automates appointment management for service businesses. Our voice assistant handles calls, schedules appointments, sends reminders, and optimizes your calendar 24/7.'
    },
    q2: {
      question: 'What types of businesses is it for?',
      answer: 'VELXIA is ideal for any business that manages appointments: medical clinics, beauty centers, law firms, consultancies, educational centers, and any service business that needs to optimize their scheduling.'
    },
    q3: {
      question: 'How long does implementation take?',
      answer: 'Most businesses are operational in less than 48 hours. The process includes initial setup, AI training with your tone and protocols, and testing before full launch.'
    },
    q4: {
      question: 'Do I need technical knowledge?',
      answer: 'No. VELXIA is designed to be intuitive and easy to use. We handle all technical setup and provide complete training for your team.'
    },
    q5: {
      question: 'Can I try it before committing?',
      answer: 'Yes, all plans include a 14-day free trial. No credit card required. You can test all features and see results before making a decision.'
    }
  },
  technical: {
    title: 'Technical',
    q1: {
      question: 'How does the AI assistant work?',
      answer: 'Our AI assistant uses advanced natural language processing to understand and respond to calls naturally. It learns your tone, protocols, and business rules to provide a personalized experience.'
    },
    q2: {
      question: 'Does it integrate with my current calendar?',
      answer: 'Yes, VELXIA integrates with Google Calendar, Outlook, Apple Calendar, and most popular calendar systems. Synchronization is automatic and bidirectional.'
    },
    q3: {
      question: 'What happens if the AI doesn\'t understand something?',
      answer: 'If the AI encounters a situation it cannot handle, it can transfer the call to your team or schedule a callback. The system continuously learns from these interactions to improve.'
    },
    q4: {
      question: 'Can I customize the AI\'s responses?',
      answer: 'Yes, you have full control over the AI\'s tone, responses, and protocols. You can define how it should handle different situations and what information it should request.'
    },
    q5: {
      question: 'Does it work in multiple languages?',
      answer: 'Yes, our AI assistant supports multiple languages including Spanish, English, French, German, and Italian. It can automatically detect and respond in the client\'s language.'
    }
  },
  pricing: {
    title: 'Pricing & Plans',
    q1: {
      question: 'How much does VELXIA cost?',
      answer: 'We have plans from €99/month for small businesses up to custom solutions for large enterprises. All plans include free trial and no setup fees.'
    },
    q2: {
      question: 'Can I change plans?',
      answer: 'Yes, you can upgrade or downgrade your plan at any time. Changes take effect immediately and we adjust billing proportionally.'
    },
    q3: {
      question: 'Are there additional costs?',
      answer: 'Plans include a specific number of monthly appointments. If you exceed your limit, you can upgrade your plan or pay a small additional fee per extra appointment. There are no hidden costs.'
    },
    q4: {
      question: 'Do you offer annual discounts?',
      answer: 'Yes, if you pay annually you get 2 months free, equivalent to a 16% discount on the total price.'
    },
    q5: {
      question: 'Can I cancel at any time?',
      answer: 'Yes, there are no permanence contracts. You can cancel your subscription at any time from your control panel. We will not charge you for the following month.'
    }
  },
  security: {
    title: 'Security & Privacy',
    q1: {
      question: 'Is my data secure?',
      answer: 'Yes, we use bank-level encryption (AES-256) for all data. Our servers are in Europe and comply with GDPR. We perform regular security audits.'
    },
    q2: {
      question: 'Who has access to my information?',
      answer: 'Only you and your authorized team have access to your data. Our support team can only access with your explicit permission and for specific technical issues.'
    },
    q3: {
      question: 'Are calls recorded?',
      answer: 'Calls can be recorded if you enable this option (recommended for quality and training). Recordings are encrypted and stored securely. You can delete them at any time.'
    },
    q4: {
      question: 'Is it HIPAA compliant?',
      answer: 'Yes, our Enterprise plan includes HIPAA compliance for healthcare businesses. We sign BAA (Business Associate Agreement) and comply with all required regulations.'
    },
    q5: {
      question: 'What happens to my data if I cancel?',
      answer: 'You can export all your data at any time. After cancellation, we keep your data for 30 days in case you want to return. After that period, it is permanently deleted.'
    }
  },
  cta: {
    title: 'Didn\'t Find Your Answer?',
    subtitle: 'Contact us and we will be happy to help you',
    button: 'Contact Us'
  }
};
